import React, { useState } from "react";
import Logo from "../assets/images/logo-hover.png";
import TopIcon from "../assets/images/top-arrow.svg";
import Contact from "./Contact";
import "./style.css";
function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="footer-container-wrapper">
      <div className="footer-container">
        <div className="logo-container">
          <img className="footer-logo" src={Logo} alt="Equinox" />
        </div>
        <div className="support-service-container">
          <div className="support-service-container-contents">
            <h5 className="support-service-content">Support</h5>
            <ul className="supports-services-lists">
              <li className="supports-services-list">Terms of service</li>
              <li className="supports-services-list">Privacy policy</li>
              <li
                className="supports-services-list"
                onClick={() => setIsModalOpen(true)}
              >
                Contact
              </li>
            </ul>
          </div>
          <Contact show={isModalOpen} onClose={() => setIsModalOpen(false)} />
          <div className="support-service-container-contents">
            <h5 className="support-service-content">Socials</h5>
            <ul className="supports-services-lists">
              <li className="supports-services-list">
                <a
                  className="supports-services-list"
                  href="https://www.linkedin.com/company/equinox-tech-solution/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Linkedin
                </a>
              </li>
              <li className="supports-services-list">
                <a
                  className="supports-services-list"
                  href="https://www.instagram.com/equinox_tech4?igsh=eG1rMnRtY2xuYjd0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li className="supports-services-list">
                <a
                  className="supports-services-list"
                  href="https://www.facebook.com/share/1AiSPVJ987/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr className="divider" />
      <div className="copy-rights-container">
        <div className="">
          <p className="copy-right-text">
            © 2023 Equinox Tech Solutions | All Rights Reserved
          </p>
        </div>
        <div className="back-top-cont" onClick={scrollToTop}>
          <p className="back-to-top-text">Back to top</p>
          <img src={TopIcon} alt="BackToTop" />
        </div>
      </div>
    </div>
  );
}

export default Footer;
